module.exports = __webpack_public_path__ + "img/collection2.b96dc649.jpg";